import { render, staticRenderFns } from "./FlowSingle.vue?vue&type=template&id=4049a08b"
import script from "./FlowSingle.vue?vue&type=script&lang=js"
export * from "./FlowSingle.vue?vue&type=script&lang=js"
import style0 from "./FlowSingle.vue?vue&type=style&index=0&id=4049a08b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports